export default function DefaultBlankPage(){
    return (
        <div className="mt-5">
          <div className="d-flex align-items-center justify-content-center">
            <h3 className="text-danger">Service Unavailable</h3>
          </div>
        </div>
    );
}